import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import HorizontalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/HorizontalAlignment';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DividerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/dividerItemAttributes';

import DividerStyle from './DividerStyle';

const Divider = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<DividerItemAttributes>) => {
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();

  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };
  const defaultBgColor = networkColors?.button_primary;
  const settingProps = {
    defaultAttributes: {
      ...defaultAttributes,
      dividerColor: defaultAttributes?.dividerColor || defaultBgColor,
    },
    item,
    onChange,
  };

  return (
    <AccordionTitle isInitiallyOpen title={__('Divider')}>
      <DividerStyle {...settingProps} />
      <NumberSetting
        settingKey="dividerHeight"
        title={__('Height')}
        {...settingProps}
      />
      <NumberSetting
        settingKey="dividerWidth"
        title={__('Width')}
        {...settingProps}
      />
      <ColorSetting
        settingKey="dividerColor"
        title={__('Divider Color')}
        transparent={false}
        {...settingProps}
        {...colorSettingsProps}
      />
      <HorizontalAlignment title={__('Alignment')} {...settingProps} />
    </AccordionTitle>
  );
};

export default Divider;
